import React, { useContext } from 'react';
import { appContext } from '../../App';
import { lang } from '../../util/constants';
import { AiOutlineGift, AiOutlineMessage } from 'react-icons/ai';
import Form from 'react-bootstrap/Form';

import './footer.css';

const Footer = () => {

   const { setLanguage, language } = useContext(appContext);

   return (
      <div className='footer-container d-flex align-items-center'>
         <div className='f-head d-flex'>
            <div className='f-heading d-flex align-items-center'>
               <a className='a-intro' href='#begin'>Allan Baltazar</a>
            </div>
         </div>
         <div className='f-links d-flex justify-content-center align-items-center h-100'>
            <div className='f-link with-border d-flex justify-content-center align-items-center'><a href='#wishlist-container'><AiOutlineGift /></a></div>
            <div className='f-link with-border2 d-flex justify-content-center align-items-center'><a href='#mu-container'><AiOutlineMessage /></a></div>
            <div className='d-flex justify-content-center align-items-center'>
               <Form.Control as='select' onChange={e => setLanguage(e.target.value)} style={{paddingLeft: '0', width:'4.1rem'}}>
                  <option className='d-flex' value={lang.pt} selected={language === lang.pt}>
                     Português
                  </option>
                  <option className='d-flex' value={lang.en} selected={language === lang.en}>
                     English
                  </option>
               </Form.Control>
            </div>
            <div className='f-lang-message'>
               <div>{language === lang.pt ? 'Change language' : 'Mudar idioma'}</div>
               <div className='f-triangle'></div>
            </div>
         </div>
      </div>
   )
}

export default Footer
